import { Controller } from "@hotwired/stimulus";
import { initPurchasesDatatable, updatePurchaseInvoicesTableRows } from "../../datatables/purchase_invoices_datatable";
import { dataTableFunctions, isDatatableUninitialized } from "../../datatables/datatable_functions";

export default class extends Controller {
  initialize() {
    if (isDatatableUninitialized(this.element)) {
      initPurchasesDatatable(this.element);

      document.addEventListener("purchaseInvoice:updated", (e) => {
        updatePurchaseInvoicesTableRows(e.detail.purchaseInvoices);
      });

      document.addEventListener("datatable:reload", () => {
        dataTableFunctions().reloadTable(this.element.id);
      });
    }
  }
}
